import { useMutation, useQueryClient } from "@tanstack/react-query";
import { partyLicensesKeys } from "Api/Queries/Licenses/usePartyLicensesQuery";
import { deleteLicensesLicensePublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
};

export const useDeleteLicenseMutation = ({ onSuccess }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicID: string) =>
      deleteLicensesLicensePublicID(publicID),
    ),
    onSuccess: () => {
      onSuccess?.();
      queryClient.invalidateQueries({ queryKey: partyLicensesKeys.all });
    },
  });
};
